import "./chunk-SUJGGKVT.mjs";
import {
  withDefaultProps
} from "./chunk-UONXFRGI.mjs";
import {
  withDefaultColorScheme
} from "./chunk-DFL6DXJX.mjs";
import {
  withDefaultSize
} from "./chunk-YKDMERD6.mjs";
import {
  withDefaultVariant
} from "./chunk-HA5PBA4B.mjs";
import {
  extendBaseTheme,
  extendTheme,
  mergeThemeOverride
} from "./chunk-AQYX3YP4.mjs";
export {
  extendBaseTheme,
  extendTheme,
  mergeThemeOverride,
  withDefaultColorScheme,
  withDefaultProps,
  withDefaultSize,
  withDefaultVariant
};
